import React from 'react';

import './src/scss/styles.scss';

import Layout from './src/components/ui/Layout';

export const wrapPageElement = ({ element, props }) => {
	return <Layout {...props}>{element}</Layout>;
};